import { Mail } from 'lucide-react'
import { Tooltip } from 'react-tooltip'
import { SessionManager } from '../../utils'

export default function ActionMail(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))
    const routeNames = Array.isArray(route_name) ? route_name : [route_name]
    const allowed = permission?.some((val) => routeNames.includes(val.sub_action_name))

    return (
        <>
            {allowed &&
                <Mail size={16} className='action_btn text-warning me-3'
                    onClick={onClick}
                    data-tooltip-id='mail'
                    data-tooltip-content={text}
                    data-tooltip-place="left"
                />
            }

            <Tooltip id='mail' className='bg-warning tooltip_msg' place="left" />
        </>
    )
}
